(function () {
  'use strict';

  var DEBOUNCE_MS = 250;
  // Matches both AJAX API paths (/cart/add.js) and the suffix-less routes the
  // theme uses via routes.cart_add_url etc. (/cart/add, possibly with ?query).
  var MUTATING_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/;

  // Re-sync cart metafields (line items + volumes + attribution values) after a
  // cart change. The actual write lives in apex-attribution.js and dedupes
  // internally; we just fetch the fresh cart and hand it over.
  var recomputeTimer = null;
  function scheduleRecompute() {
    if (recomputeTimer) clearTimeout(recomputeTimer);
    recomputeTimer = setTimeout(recomputeCartMetafields, DEBOUNCE_MS);
  }

  function recomputeCartMetafields() {
    if (typeof window.__APEX_SYNC_CART_METAFIELDS__ !== 'function') return;
    // Enrollment has taken authoritative control of the metafields — stand down.
    if (window.__APEX_SKIP_AUTO_SYNC__) return;
    return fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        try {
          window.__APEX_SYNC_CART_METAFIELDS__(cart);
        } catch (e) {}
      })
      .catch(function () {});
  }

  function onQtyChange(e) {
    var t = e.target;
    if (!t || t.tagName !== 'INPUT') return;
    if (t.name !== 'quantity' && !/quantity/i.test(t.name || '')) return;
    scheduleRecompute();
  }

  function wrapFetchForCartMutations() {
    if (typeof window.fetch !== 'function') return;
    if (window.__APEX_CART_FETCH_WRAPPED__) return;
    window.__APEX_CART_FETCH_WRAPPED__ = true;
    var orig = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = '';
      if (typeof input === 'string') url = input;
      else if (input && input.url) url = input.url;
      var willMutate = MUTATING_PATTERN.test(url);
      var p = orig(input, init);
      if (willMutate) {
        p.then(scheduleRecompute, function () {});
      }
      return p;
    };
  }

  function subscribeToThemePubsub() {
    if (typeof window.subscribe !== 'function') return;
    if (typeof window.PUB_SUB_EVENTS !== 'object' || !window.PUB_SUB_EVENTS) return;
    var events = ['cartUpdate', 'cartDrawerUpdate'];
    for (var i = 0; i < events.length; i++) {
      var name = window.PUB_SUB_EVENTS[events[i]];
      if (name) {
        try {
          window.subscribe(name, scheduleRecompute);
        } catch (e) {}
      }
    }
  }

  function init() {
    document.addEventListener('change', onQtyChange);
    document.addEventListener('input', onQtyChange);

    wrapFetchForCartMutations();
    subscribeToThemePubsub();

    scheduleRecompute();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
